/* eslint-disable */
//import {$,jQuery} from 'jquery';
import './jquery-global';
import Parallax from './parallax.js';


if($(".js-text-parallax")) {

  let initScene = false;
  let initParallax = false;
  let sceneParallax;
  let imageParallax;
  
  let screenXS = false;
  let screenSM = false;
  let screenXL = false;


function checkVisible() {
    let elm                                                         = this;
    let vis                                                        = vis || "visible";
    let vpH = $( window ).height(), st = $( window ).scrollTop(), y = $( elm ).offset().top,
        elementHeight                                               = $( elm ).height();
  
    if( vis == "visible" ) return ((y < (vpH + st)) && (y > (st - elementHeight)));
  
    console.log(vis);
  }
  
  
  $( document ).ready( function( $ ) {
  
    $( window ).scroll( function() {
      $( '.reveal' ).filter( checkVisible ).addClass( 'is-visible' );
    } ).scroll();
  
    // Smooth scroll animation
    $( '.js-btn-scroll' ).click( function() {
        $( 'html, body' ).animate( {
            scrollTop : $( $.attr( this, 'href' ) ).offset().top - 50
        }, 750 );
        return false;
    } );
  
    // Get svg path length, just for animating the dash
    setStroke( document.getElementById( 'beam' ) );
  
    function setStroke( path ) {
      if (!path) return;
        let pathLength = path.getTotalLength();
  
        path.setAttribute( 'stroke-dasharray', pathLength );
        path.setAttribute( 'stroke-dashoffset', pathLength );
    }
  
  } );
  
  $( window ).on( 'load resize orientationchange', function( e ) {
    let viewport_width = $( window ).width();
  
    // Init scene parallax
    if( initScene === false ) {
        initScene = true;
  
        sceneParallax = new Parallax( '.js-parallax', {
            offsetYBounds : -100,
            safeHeight    : 0.10
        } ).init();
    }
  
    // Only start parallax for the image sections over a certain size
    if( viewport_width > 768 && initParallax === false ) {
        console.log( "Window is greater than 768 and parallax isnt on" );
        initParallax = true;
  
        imageParallax = new Parallax( '.js-text-parallax' ).init()
  
        imageParallax.on( 'draw', function( image ) {
  
            if( $( image ).hasClass( 'is-waiting' ) ) {
                $( image ).removeClass( 'is-waiting' )
            }
        } );
    }
  
    // Update parallax effect for the scene based on screen size, otherwise it looks shit
    if( viewport_width < 768 && screenXS === false ) {
        console.log( "Initializing parallax for XS screens" );
        screenXS = true;
        screenSM = false;
        screenXL = false;
  
        sceneParallax.destroy();
  
        $( '.scene__layer--5' ).attr( 'data-intensity', 2 + 8 );
        $( '.scene__layer--4' ).attr( 'data-intensity', 3 + 8 );
        $( '.scene__layer--3' ).attr( 'data-intensity', 4 + 8 );
        $( '.scene__layer--2' ).attr( 'data-intensity', 2 + 8 );
        $( '.scene__layer--1' ).attr( 'data-intensity', 2 );
  
        $( '.scene__birds--1' ).attr( 'data-intensity', -20 - 8 );
        $( '.scene__birds--2' ).attr( 'data-intensity', -10 - 8 );
  
        sceneParallax = new Parallax( '.js-parallax', {
            offsetYBounds : -0,
            intensity     : 10,
            safeHeight    : 0.15
        } ).init();
    }
  
    // Update parallax effect for the scene based on screen size, otherwise it looks shit
    if( viewport_width > 768 && viewport_width < 1200 && screenSM === false ) {
        console.log( "Initializing parallax for SM screens" );
        screenXS = false;
        screenSM = true;
        screenXL = false;
  
        sceneParallax.destroy();
  
        $( '.scene__layer--5' ).attr( 'data-intensity', 25 - 15 );
        $( '.scene__layer--4' ).attr( 'data-intensity', 35 - 15 );
        $( '.scene__layer--3' ).attr( 'data-intensity', 45 - 15 );
        $( '.scene__layer--2' ).attr( 'data-intensity', 20 - 15 );
        $( '.scene__layer--1' ).attr( 'data-intensity', 2 );
  
        $( '.scene__birds--1' ).attr( 'data-intensity', -200 + 40 );
        $( '.scene__birds--2' ).attr( 'data-intensity', -100 + 40 );
  
        sceneParallax = new Parallax( '.js-parallax', {
            offsetYBounds : -100,
            intensity     : 20,
            safeHeight    : 0.15
        } ).init();
    }
  
    // Update parallax effect for the scene based on screen size, otherwise it looks shit
    if( viewport_width > 1200 && screenXL === false ) {
        console.log( "Initializing parallax for xl screens" );
        screenXS = false;
        screenSM = false;
        screenXL = true;
  
        sceneParallax.destroy();
  
        $( '.scene__layer--5' ).attr( 'data-intensity', 25 );
        $( '.scene__layer--4' ).attr( 'data-intensity', 35 );
        $( '.scene__layer--3' ).attr( 'data-intensity', 45 );
        $( '.scene__layer--2' ).attr( 'data-intensity', 20 );
        $( '.scene__layer--1' ).attr( 'data-intensity', 2 );
  
        $( '.scene__birds--1' ).attr( 'data-intensity', -230 );
        $( '.scene__birds--2' ).attr( 'data-intensity', -130 );
  
        sceneParallax = new Parallax( '.js-parallax', {
            offsetYBounds : -200,
            intensity     : 30,
            safeHeight    : 0.15
        } ).init();
    }
  } );
  
  /**
  * Make sure the scene draw call is made
  * Toggling of this class is purely for visual bug fixing purposes
  */
  $( window ).on( 'scroll orientationchange', function() {
    if( initScene ) {
        sceneParallax.on( 'draw', function( image ) {
            if( $( '.scene' ).hasClass( 'is-waiting' ) ) {
                $( '.scene' ).removeClass( 'is-waiting' );
            }
        } );
    }
  } )
  
  /**
  * Hide the stars in the header based on scroll position to optimize browser rendering
  */
  let opacity = 1;
  
  $( window ).on( 'scroll orientationchange', function( e ) {
    let scrollY = $( window ).scrollTop();
  
    if( scrollY > $( '.header' ).height() * 2 ) {
        if( opacity > 0 ) {
            opacity -= 0.1;
            $( '.stars' ).css( 'opacity', opacity );
        } else if( opacity <= 0 ) {
            $( '.stars' ).css( 'display', 'none' );
            $( '.stars' ).css( 'animation', 'none' );
        }
    } else {
        if( opacity <= 0 ) {
            $( '.stars' ).css( 'display', 'block' );
        }
        if( opacity < 1 ) {
            opacity += 0.1;
            $( '.stars' ).css( 'opacity', opacity );
            $( '.stars' ).css( 'animation', '' );
        }
    }
  } );
}1


// WEBPACK FOOTER //
// ./scripts/components/history.js